import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Download, RefreshCw } from "lucide-react";
import { PageHeader } from "./_shared";

const n = (v) => Number(v || 0).toLocaleString("en-IN");

export default function CustomerCohortsReport() {
  const [data, setData] = useState(null);
  const [refDate, setRefDate] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/kpi-reports/customer-cohorts", { params: refDate ? { ref_date: refDate } : {}, timeout: 90000 });
      setData(r.data);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not load cohorts. Try again.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const csv = () => {
    const lines = ["Cohort,Database count", ...(data?.rows || []).map((r) => `"${r.cohort}",${r.count}`)];
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob(["\ufeff" + lines.join("\n")], { type: "text/csv" }));
    a.download = `customer-cohorts-${data?.reference_date || "latest"}.csv`;
    a.click();
  };

  return (
    <div data-testid="customer-cohorts-page">
      <PageHeader title="Customer Base Cohorts" subtitle="ACTIVE · LAPSED · ONE-TIMER · REPEAT" />
      <div className="p-4 md:p-8 space-y-4">
        <div className="flex flex-wrap items-end gap-3">
          <label className="text-xs text-neutral-600">Reference date (blank = latest bill date)
            <input type="date" className="k-input block mt-1" value={refDate} onChange={(e) => setRefDate(e.target.value)} data-testid="cohorts-ref-date" />
          </label>
          <button className="k-btn k-btn-outline k-btn-sm" onClick={load} disabled={loading} data-testid="cohorts-refresh-btn">
            <RefreshCw className={`w-3.5 h-3.5 ${loading ? "animate-spin" : ""}`} /> {loading ? "Counting…" : "Run"}
          </button>
          <button className="k-btn k-btn-outline k-btn-sm" onClick={csv} disabled={!data} data-testid="cohorts-export-btn">
            <Download className="w-3.5 h-3.5" /> CSV
          </button>
        </div>
        {data && (
          <div className="chart-card p-5" data-testid="cohorts-table-card">
            <div className="text-xs text-neutral-500 mb-3" data-testid="cohorts-ref-note">
              Reference date <b>{data.reference_date}</b> ({data.reference_basis}). Windows: 3m = 90, 6m = 180, 9m = 270, 12m = 365 days.
            </div>
            <table className="w-full text-sm" data-testid="cohorts-table">
              <thead><tr className="text-left text-neutral-500 border-b"><th className="py-2">Cohort</th><th className="text-right">Database count</th></tr></thead>
              <tbody>
                {data.rows.map((r, i) => (
                  <tr key={r.cohort} className="border-b last:border-0" data-testid={`cohort-row-${i}`}>
                    <td className="py-2">{r.cohort}</td><td className="text-right tabular-nums">{n(r.count)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
